import { render, staticRenderFns } from "./SadadMemberCallback.vue?vue&type=template&id=d58d52f6&scoped=true"
import script from "./SadadMemberCallback.vue?vue&type=script&lang=js"
export * from "./SadadMemberCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58d52f6",
  null
  
)

export default component.exports